// Support case enums (kept in sync with the backend CHECK constraints in
// src/migrations/pending/2026-07-01-support-cases-schema.js).

export const CASE_TYPES = [
  { value: 'bug', label: 'Bug', badgeClass: 'type-bug' },
  { value: 'question', label: 'Question', badgeClass: 'type-question' },
  { value: 'feature_request', label: 'Feature request', badgeClass: 'type-feature_request' },
];

export const CASE_STATUSES = [
  { value: 'open', label: 'Open' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'waiting_on_user', label: 'Waiting on you' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'closed', label: 'Closed' },
];

export const CASE_PRIORITIES = [
  { value: 'low', label: 'Low' },
  { value: 'normal', label: 'Normal' },
  { value: 'high', label: 'High' },
];

const labelFrom = (list, value) => list.find((o) => o.value === value)?.label || value || '';

/** Global cross-tenant case reference, e.g. "SC-142". */
export const refLabel = (ref) => (ref != null && ref !== '' ? `SC-${ref}` : '');

export const typeLabel = (v) => labelFrom(CASE_TYPES, v);
export const statusLabel = (v) => labelFrom(CASE_STATUSES, v);
export const priorityLabel = (v) => labelFrom(CASE_PRIORITIES, v);

/** Full display metadata for a case type (label, icon, badge className). */
export const typeMeta = (v) =>
  CASE_TYPES.find((t) => t.value === v) || { value: v, label: v || '', badgeClass: '' };
